<div class="flex flex-col flex-auto min-w-0">
    <div class="sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between pb-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Croquis</div>
            <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8">
                <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
                    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="store()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2 mr-1">Ajouter</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid grid-cols-3 z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>Nom</div>
                        <div>Étage</div>
                        <div class="text-right">Détails</div>
                    </div>
                    <ng-container *ngFor="let dossierCroqui of dossierCroquis; trackBy: trackByFn">
                        <div class="table-grid grid grid-cols-3 items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <div class="">
                                <a target='_blank' [routerLink]="['/croquis/', dossierCroqui.dossier_intervention_id, dossierCroqui.fiche_intervention_id, dossierCroqui.etage_id]" class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button>
                                    {{dossierCroqui.nom}}
                                </a>
                            </div>
                            <div class="">{{dossierCroqui.nom_niveau}}</div>
                            <div class="text-right">
                                <button class="min-w-10 min-h-7 mx-0.5 h-7 px-2 leading-6" mat-stroked-button (click)="update(dossierCroqui)">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                </button>
                                <button class="min-w-10 min-h-7 mx-0.5 h-7 px-2 leading-6" mat-stroked-button (click)="afficher_image(dossierCroqui.etage_id)">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                </button>
                                <button class="min-w-10 min-h-7 h-7 mx-0.5 px-2 leading-6" mat-stroked-button (click)="destroy(dossierCroqui)" *ngIf="isAdmin">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div id="croquis_image_svg" style="width: fit-content; padding: 10px; position: absolute; top:-2000px;">
        <img src="assets/images/logo/logo_urgex.jpg" style="margin:auto; margin-bottom: 30px; max-width: 200px;">
        <div id="croquis_image_svg_content" style="width: fit-content;">
        </div>
    </div>
    <div id="croquis_image_png" style="width: fit-content; position: absolute; top:-2000px;">
    </div>
</div>
